/**
* RMKM Phase 2 Changes
* added by @ali 
* date : 14 April 2025
* Added new component attendance report to fetch staff login history
*  */
import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Table } from 'react-bootstrap';
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableHeader
} from 'react-bs-datatable';
import inventoryApi from '../api/inventoryApi';
import moment from 'moment';
import { Link } from 'react-router-dom';
export default function UserTracking() {
    const [body,setBody] = useState([]);
    const [header,setHeader] = useState([
        {
            title:'Staff Name',
            prop:'parent_name',
            // cell:(row)=>(<Link to={`/staffmembers/${row?.parentid}`}>{row?.parent_name}</Link>),
            isFilterable:true
        },
        {
            title:'Check-in Time',
            prop:'logindatetime',
            cell:(row)=>row?.logindatetime ? moment(row.logindatetime).format('YYYY-MM-DD') : '',
            isFilterable:true
        },
        {
            title:'Check_out Time',
            prop:'logoutdatetime',
            cell:(row)=>row?.logoutdatetime ? moment(row.logoutdatetime).format('YYYY-MM-DD') : '',
            isFilterable:true
        },
        {
            title:'Location',
            prop:'location',
            isFilterable:true
        },
        {
            title:'Remarks',
            prop:'remarks',
            isFilterable:true
        },
    ]);
    async function fetchData(){
        const result = await inventoryApi.fetchAllUserTrackingRec()
        if(Array.isArray(result)){
            setBody(result);
        } else { 
            setBody([]);
        }
    }
    useEffect(()=>{
        fetchData();
    },[]);
    return (
        <Container>
            <DatatableWrapper body={body} headers={header} paginationOptionsProps={{
                initialState: {
                    rowsPerPage: 20,
                    options: [5, 10, 15, 20]
                }
            }}>
                <Row className='align-items-end'>
                    <Col md={3}>
                        <Filter/>
                    </Col>
                    <Col
                     md={1}
                    >
                    <PaginationOptions labels={{beforeSelect:' '}} />

                    </Col>
                </Row>
                <Table striped className="mt-4 data-table">
                    <TableHeader />
                    <TableBody />
                </Table>
                <Pagination />

            </DatatableWrapper>
        </Container>
    )
}
